module.exports = __webpack_public_path__ + "img/address.9c82e409.png";